import React from "react";
import Icon from "../../../components/AppIcon";

const StatsSection = ({ activeCategory, categories }) => {
  const currentCategory = categories?.find((cat) => cat?.id === activeCategory);

  const getStatsData = () => {
    switch (activeCategory) {
      case "events":
        return [
          {
            icon: "Heart",
            value: "500+",
            label: "Love Stories Captured",
            color: "#E8B4A0",
          },
          {
            icon: "Users",
            value: "1,200+",
            label: "Happy Couples",
            color: "#E8B4A0",
          },
          {
            icon: "Award",
            value: "25+",
            label: "Wedding Awards",
            color: "#E8B4A0",
          },
          {
            icon: "Clock",
            value: "2,000+",
            label: "Hours of Memories",
            color: "#E8B4A0",
          },
        ];
      case "realestate":
        return [
          {
            icon: "Home",
            value: "800+",
            label: "Properties Showcased",
            color: "#4A90A4",
          },
          {
            icon: "TrendingUp",
            value: "35%",
            label: "Average Sale Speed Increase",
            color: "#4A90A4",
          },
          {
            icon: "DollarSign",
            value: "$2.5B+",
            label: "Property Value Marketed",
            color: "#4A90A4",
          },
          {
            icon: "MapPin",
            value: "50+",
            label: "Cities Covered",
            color: "#4A90A4",
          },
        ];
      case "marketing":
        return [
          {
            icon: "Target",
            value: "200+",
            label: "Campaigns Launched",
            color: "#FF6B35",
          },
          {
            icon: "Eye",
            value: "50M+",
            label: "Total Views Generated",
            color: "#FF6B35",
          },
          {
            icon: "Zap",
            value: "300%",
            label: "Average Engagement Boost",
            color: "#FF6B35",
          },
          {
            icon: "Trophy",
            value: "15+",
            label: "Marketing Awards",
            color: "#FF6B35",
          },
        ];
      case "design":
        return [
          {
            icon: "Lightbulb",
            value: "100+",
            label: "Concepts Visualized",
            color: "#00D4AA",
          },
          {
            icon: "Globe",
            value: "20+",
            label: "Countries Reached",
            color: "#00D4AA",
          },
          {
            icon: "Cpu",
            value: "500+",
            label: "Hours of Innovation",
            color: "#00D4AA",
          },
        ];
      default:
        return [];
    }
  };

  const stats = getStatsData();

  const getSectionStyle = () => {
    switch (activeCategory) {
      case "events":
        return "bg-gradient-to-r from-rose-500/10 to-pink-500/10";
      case "realestate":
        return "bg-gradient-to-r from-blue-500/10 to-slate-500/10";
      case "marketing":
        return "bg-gradient-to-r from-orange-500/10 to-red-500/10";
      case "design":
        return "bg-gradient-to-r from-gray-900 to-black";
      default:
        return "bg-gray-50";
    }
  };

  return (
    <section
      className={`py-16 ${getSectionStyle()} transition-all duration-1000`}
    >
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2
            className={`text-3xl font-bold mb-4 ${
              activeCategory === "design" ? "text-white" : "text-gray-900"
            }`}
          >
            {currentCategory?.name} by the Numbers
          </h2>
          <p
            className={`text-lg max-w-2xl mx-auto ${
              activeCategory === "design" ? "text-gray-300" : "text-gray-600"
            }`}
          >
            Our track record speaks for itself across every project and client
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats?.map((stat, index) => (
            <div
              key={index}
              className={`text-center p-6 rounded-2xl transition-all duration-500 hover:scale-105 ${
                activeCategory === "design"
                  ? "bg-gray-800/50 backdrop-blur-sm border border-gray-700"
                  : "bg-white/80 backdrop-blur-sm shadow-lg"
              }`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div
                className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center"
                style={{ backgroundColor: `${stat?.color}20` }}
              >
                <Icon name={stat?.icon} size={28} color={stat?.color} />
              </div>
              <div
                className={`text-3xl font-bold mb-2 ${
                  activeCategory === "design" ? "text-white" : "text-gray-900"
                }`}
              >
                {stat?.value}
              </div>
              <div
                className={`text-sm font-medium ${
                  activeCategory === "design"
                    ? "text-gray-300"
                    : "text-gray-600"
                }`}
              >
                {stat?.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
